import AUDITORIAS_TABLERO_RESUMEN from '@/graphql/querys/administracion/auditorias/auditoriasTableroResumen.gql';
import CATALOGO_AUDITORIA_ETIQUETAS from '@/graphql/querys/administracion/auditorias/catalogo-etiquetas/catalogoAuditoriaEtiquetas.gql';

export default {
  apollo: {
    auditoriasTablero: {
      query: AUDITORIAS_TABLERO_RESUMEN,
      variables() {
        return {
          filtros: {
            idEnteFiscalizador: this.filtros.enteFiscalizador,
            ejercicioDel: this.filtros.ejercicioDel,
            ejercicioAl: this.filtros.ejercicioAl,
            idAuditoria: this.filtros.auditoriaSelected,
          },
        };
      },
    },
    catalogoAuditoriaEtiquetas: {
      query: CATALOGO_AUDITORIA_ETIQUETAS,
    },
  },
  methods: {
    mixActualizarDatos() {
      this.$apollo.queries.auditorias.refetch();
      this.$apollo.queries.catalogoAuditoriaEtiquetas.refetch();
    },
    setAuditoriasFiltro() {
      this.filtros.auditorias = this.mixGetAuditorias;
    },
    getDesglose(observaciones) {
      const datosDesgloses = {
        desglose: 0,
        desgloseSolventado: 0,
        desglosePorSolventar: 0,
        desgloseEnviadoEnte: 0,
        desglosePorEnviar: 0,
      };
      if (observaciones.length < 1) return datosDesgloses;
      let totalDesglose = 0;
      let desgloseSolventado = 0;
      let desglosePorSolventar = 0;
      let desgloseEnviadoEnte = 0;
      let desglosePorEnviar = 0;
      // contar todos los desgloses
      observaciones.forEach((observacion) => {
        totalDesglose += observacion.detalles.length;
      });
      observaciones
        .filter((observacion) => observacion.estatus === 'SOLVENTADA')
        .forEach((observacion) => {
          desgloseSolventado += observacion.detalles.length;
        });
      observaciones
        .filter((observacion) => observacion.estatus !== 'SOLVENTADA')
        .forEach((observacion) => {
          desglosePorSolventar += observacion.detalles.length;
          const enviadosEnte = observacion.detalles.filter((detalle) => detalle.enviado);
          const sinEnviarEnte = observacion.detalles.filter((detalle) => !detalle.enviado);
          desgloseEnviadoEnte += enviadosEnte.length;
          desglosePorEnviar += sinEnviarEnte.length;
        });
      datosDesgloses.desglose = totalDesglose;
      datosDesgloses.desgloseSolventado = desgloseSolventado;
      datosDesgloses.desglosePorSolventar = desglosePorSolventar;
      datosDesgloses.desgloseEnviadoEnte = desgloseEnviadoEnte;
      datosDesgloses.desglosePorEnviar = desglosePorEnviar;

      return {
        ...datosDesgloses,
      };
    },
    getDatosObservaciones(informes) {
      const todasLasObservaciones = [];
      informes.forEach((informe) => {
        todasLasObservaciones.push(...informe.observaciones);
      });
      // Cantidad de observaciones
      const cantidadObservaciones = todasLasObservaciones.length;
      // Importe de todas las observaciones
      const totalObservacionesImporte = this.$ObjSumar(todasLasObservaciones, 'montoOriginal');
      // Importe pendiente de todas las observaciones
      const totalObservacionesImportePendiente = this.$ObjSumar(
        todasLasObservaciones,
        'montoPendiente',
      );
      // Observaciones solventadas
      const solventadas = todasLasObservaciones.filter(
        (observacion) => observacion.estatus === 'SOLVENTADA',
      );
      // Cantidad de observaciones solventadas
      const cantidadSolventadas = solventadas.length;
      // Observaciones pendientes
      const pendientes = todasLasObservaciones.filter(
        (observacion) => observacion.estatus === 'PENDIENTE',
      );
      // Cantidad de observaciones pendientes
      const cantidadPendientes = pendientes.length;
      // Importe de observaciones solventadas
      const solventadasImporte = this.$ObjSumar(solventadas, 'montoOriginal');
      // Importe de observaciones pendientes
      const solventadasImportePendiente = this.$ObjSumar(solventadas, 'montoPendiente');
      // Observaciones por solventar
      const porSolventar = todasLasObservaciones.filter(
        (observacion) => observacion.estatus !== 'SOLVENTADA',
      );
      // Cantidad de observaciones por solventar
      const cantidadPorSolventar = porSolventar.length;
      // Importe de observaciones por solventar
      const porSolventarImporte = totalObservacionesImporte - solventadasImporte;
      // Importe pendiente de observaciones por solventar
      const porSolventarImportePendiente = totalObservacionesImportePendiente
        - solventadasImportePendiente;
      // Observaciones por responder
      const porResponder = todasLasObservaciones.filter(
        (observacion) => observacion.estatus === 'PENDIENTE'
          || observacion.estatus === 'POR RESPONDER'
          || observacion.estatus === 'RESPUESTA ENVIADA PARCIAL',
      );
      // Cantidad observaciones por responder
      const cantidadPorResponder = porResponder.length;
      // Importe observaciones por responder
      const porResponderImporte = this.$ObjSumar(porResponder, 'montoOriginal');
      // Importe pendiente observaciones por responder
      const porResponderImportePendiente = this.$ObjSumar(porResponder, 'montoPendiente');
      // Observaciones pendientes y por responder
      const pendientesYPorResponder = porResponder.filter(
        (observacion) => observacion.estatus !== 'RESPUESTA ENVIADA PARCIAL',
      );
      // Cantidad observaciones pendientes y por responder
      const cantidadPendientesYPorResponder = pendientesYPorResponder.length;
      // Importe observaciones pendientes y por responder
      const importePendientesYPorResponder = this.$ObjSumar(
        pendientesYPorResponder,
        'montoOriginal',
      );
      // Importe pendiente observaciones pendientes y por responder
      const importePendientePendientesYPorResponder = this.$ObjSumar(
        pendientesYPorResponder,
        'montoPendiente',
      );
      // Observaciones con respuesta enviada parcial
      const respuestaEnviadaParcial = todasLasObservaciones.filter(
        (observacion) => observacion.estatus === 'RESPUESTA ENVIADA PARCIAL',
      );
      // Cantidad observaciones con respuesta enviada parcial
      const cantidadRespuestaEnviadaParcial = respuestaEnviadaParcial.length;
      // Importe observaciones con respuesta enviada parcial
      const importeRespuestaEnviadaParcial = this.$ObjSumar(
        respuestaEnviadaParcial,
        'montoOriginal',
      );
      // Importe pendiente observaciones con respuesta enviada parcial
      const importePendienteRespuestaEnviadaParcial = this.$ObjSumar(
        respuestaEnviadaParcial,
        'montoPendiente',
      );
      // Observaciones con respuesta enviada completa
      const respuestaEnviadaCompleta = todasLasObservaciones.filter(
        (observacion) => observacion.estatus === 'Respuesta Enviada Completa'
          || observacion.estatus === 'RESPUESTA ENVIADA COMPLETA',
      );
      // Cantidad observaciones con respuesta enviada completa
      const cantidadRespuestaEnviadaCompleta = respuestaEnviadaCompleta.length;
      // Importe observaciones con respuesta enviada completa
      const importeRespuestaEnviadaCompleta = this.$ObjSumar(
        respuestaEnviadaCompleta,
        'montoOriginal',
      );
      // Importe pendiente observaciones con respuesta enviada completa
      const importePendienteRespuestaEnviadaCompleta = this.$ObjSumar(
        respuestaEnviadaCompleta,
        'montoPendiente',
      );
      // Porcentaje de observaciones solventadas
      const porcentajeSolventadas = this.$numberRound(
        (cantidadSolventadas * 100) / cantidadObservaciones,
      );
      const datosDesglose = this.getDesglose(todasLasObservaciones);

      return {
        cantidadObservaciones,
        totalObservacionesImporte,
        totalObservacionesImportePendiente,
        cantidadSolventadas,
        cantidadPendientes,
        solventadasImporte,
        solventadasImportePendiente,
        porcentajeSolventadas,
        cantidadPorSolventar,
        porSolventarImporte,
        porSolventarImportePendiente,
        cantidadPorResponder,
        porResponderImporte,
        porResponderImportePendiente,
        cantidadPendientesYPorResponder,
        importePendientesYPorResponder,
        importePendientePendientesYPorResponder,
        cantidadRespuestaEnviadaParcial,
        importeRespuestaEnviadaParcial,
        importePendienteRespuestaEnviadaParcial,
        cantidadRespuestaEnviadaCompleta,
        importeRespuestaEnviadaCompleta,
        importePendienteRespuestaEnviadaCompleta,
        pendientesyPorResponder: [...pendientes, ...porResponder],
        respuestaEnviadaParcial,
        respuestaEnviadaCompleta,
        ...datosDesglose,
      };
    },
    getDetalles(observaciones) {
      const detalles = [];
      observaciones.forEach((observacion) => {
        detalles.push(...observacion.detalles);
      });
      return detalles;
    },
  },
  computed: {
    mixTarjetas() {
      const tarjetas = [
        {
          color: 'info',
          titulo: 'Observaciones Originales',
          cantidad: this.mixGetTotalesObservaciones.totalObservaciones,
          importe: this.mixGetTotalesObservaciones.importeTotalObservaciones,
          icono: 'mdi-text-box-search-outline',
        },
        {
          color: 'success',
          titulo: 'Observaciones Solventadas',
          cantidad: this.mixGetTotalesObservaciones.totalSolventadas,
          importe: this.mixGetTotalesObservaciones.importeTotalSolventadas,
          icono: 'mdi-file-document-check-outline',
        },
        {
          color: 'orange',
          titulo: 'Observaciones Por Solventar',
          cantidad: this.mixGetTotalesObservaciones.totalPorSolventar,
          importe: this.mixGetTotalesObservaciones.importeTotalPorSolventar,
          icono: 'mdi-file-document-alert-outline',
        },
      ];
      return tarjetas;
    },
    mixTabla() {
      const tabla = [
        {
          color: '#8BB10E',
          titulo: 'Pendiente y Por Responder',
          cantidad: this.mixGetTotalesObservaciones.totalPendientesYPorResponder,
          importe: this.mixGetTotalesObservaciones.importeTotalPendientesYPorResponder,
          detalles: this.getDetalles(
            this.mixGetTotalesObservaciones.observacionesPendientesyPorResponder,
          ),
        },
        {
          color: '#8BB10E',
          titulo: 'Respuesta Enviada Parcial',
          cantidad: this.mixGetTotalesObservaciones.totalRespuestaEnviadaParcial,
          importe: this.mixGetTotalesObservaciones.importeTotalRespuestaEnviadaParcial,
          detalles: this.getDetalles(
            this.mixGetTotalesObservaciones.observacionesRespuestaEnviadaParcial,
          ),
        },
        {
          color: '#8BB10E',
          titulo: 'Respuesta Enviada Completa',
          cantidad: this.mixGetTotalesObservaciones.totalRespuestaEnviadaCompleta,
          importe: this.mixGetTotalesObservaciones.importeTotalRespuestaEnviadaCompleta,
          detalles: this.getDetalles(
            this.mixGetTotalesObservaciones.observacionesRespuestaEnviadaCompleta,
          ),
        },
        {
          color: '#FDB209',
          titulo: 'Vencidas',
          cantidad: this.mixGetDatosObservacionesVencidas.vencidas.cantidad,
          importe: this.mixGetDatosObservacionesVencidas.vencidas.importe,
          detalles: this.mixGetDatosObservacionesVencidas.vencidas.detalles,
        },
        {
          color: '#FDB209',
          titulo: 'Por Vencer',
          cantidad: this.mixGetDatosObservacionesVencidas.porVencer.cantidad,
          importe: this.mixGetDatosObservacionesVencidas.porVencer.importe,
          detalles: this.mixGetDatosObservacionesVencidas.porVencer.detalles,
        },
      ];
      return tabla;
    },
    mixGraficas() {
      const graficas = [
        {
          titulo: 'Estatus de Observaciones',
          dataGrafica: {
            labels: ['Solventadas', 'Por Solventar'],
            datasets: [
              {
                backgroundColor: ['#43BC82', 'orange'],
                data: [
                  this.mixGetTotalesObservaciones.totalSolventadas,
                  this.mixGetTotalesObservaciones.totalPorSolventar,
                ],
              },
            ],
          },
        },
        {
          titulo: 'Por Solventar',
          dataGrafica: {
            labels: [
              'Pendiente y Por Solventar',
              'Respuesta Enviada Parcial',
              'Respuesta Enviada Completa',
            ],
            datasets: [
              {
                backgroundColor: ['#43BC82', 'orange', 'green'],
                data: [
                  this.mixGetTotalesObservaciones.totalPendientesYPorResponder,
                  this.mixGetTotalesObservaciones.totalRespuestaEnviadaParcial,
                  this.mixGetTotalesObservaciones.totalRespuestaEnviadaCompleta,
                ],
              },
            ],
          },
        },
        {
          titulo: 'Vencidas y Por Vencer',
          dataGrafica: {
            labels: ['Vencidas', 'Por Vencer'],
            datasets: [
              {
                backgroundColor: ['#EF5350', 'orange'],
                data: [
                  this.mixGetDatosObservacionesVencidas.vencidas.cantidad,
                  this.mixGetDatosObservacionesVencidas.porVencer.cantidad,
                ],
              },
            ],
          },
        },
      ];
      return graficas;
    },
    mixGetAuditorias() {
      if (!this.auditoriasTablero) return [];
      return this.auditoriasTablero;
      // .slice()
      // // Filtro ente fiscalizador
      // .filter(({ idEnteFiscalizador }) => {
      //   if (!this.filtros.enteFiscalizador) return true;
      //   return idEnteFiscalizador === this.filtros.enteFiscalizador;
      // })
      // // Filtro Periodo
      // .filter(({ ejercicio }) => {
      //   if (!this.filtros.ejercicioDel || !this.filtros.ejercicioAl) return true;
      //   return ejercicio >= this.filtros.ejercicioDel && ejercicio <= this.filtros.ejercicioAl;
      // })
      // // Filtro auditoria
      // .filter(({ id }) => {
      //   if (!this.filtros.auditoriaSelected) return true;
      //   return id === this.filtros.auditoriaSelected;
      // })
    },
    mixGetCatalogoAuditoriaEtiquetas() {
      if (!this.catalogoAuditoriaEtiquetas) return [];
      return this.catalogoAuditoriaEtiquetas;
    },
    mixGetDatosObservacionesVencidas() {
      if (!this.mixGetAuditorias) return [];
      const fechaHoy = new Date();
      const fechaFormateada = `${fechaHoy.getFullYear()}-${fechaHoy.getMonth()
        + 1}-${fechaHoy.getDate()}`;
      const observacionesVencidas = [];
      const observacionesPorVencer = [];
      const vencidas = {
        cantidad: 0,
        importe: 0,
        detalles: [],
      };
      const porVencer = {
        cantidad: 0,
        importe: 0,
        detalles: [],
      };
      this.mixGetAuditorias.forEach((auditoria) => {
        auditoria.informes.forEach((informe) => {
          const { fechaVencimiento } = informe;
          if (fechaVencimiento < fechaFormateada) {
            informe.observaciones.forEach((observacion) => {
              if (observacion.estatus === 'SOLVENTADA') return;
              observacionesVencidas.push(observacion);
            });
          } else {
            informe.observaciones.forEach((observacion) => {
              if (observacion.estatus === 'SOLVENTADA') return;
              observacionesPorVencer.push(observacion);
            });
          }
        });
      });
      vencidas.cantidad = observacionesVencidas.length;
      porVencer.cantidad = observacionesPorVencer.length;
      vencidas.importe = this.$ObjSumar(observacionesVencidas, 'montoOriginal');
      porVencer.importe = this.$ObjSumar(observacionesPorVencer, 'montoOriginal');
      vencidas.detalles = this.getDetalles(observacionesVencidas);
      porVencer.detalles = this.getDetalles(observacionesPorVencer);
      return {
        vencidas,
        porVencer,
      };
    },
    mixGetEntesFiscalizadores() {
      if (!this.mixGetAuditorias) return [];
      // Agregar datos de observaciones a las auditorias
      const auditoriasConDatosObservaciones = this.mixGetAuditorias.slice().map((auditoria) => ({
        ...auditoria,
        ...this.getDatosObservaciones(auditoria.informes),
      }));

      // Agrupar las auditorías por la descripción del ente Fiscalizador
      const agruparPorEnte = auditoriasConDatosObservaciones.reduce((acc, auditoria) => {
        const { descripcion } = auditoria.enteFiscalizador;

        // Si no existe el ente, se crea
        if (!acc[descripcion]) {
          acc[descripcion] = {
            nombre: descripcion,
            totalObservaciones: 0,
            importeTotalObservaciones: 0,
            importePendienteTotalObservaciones: 0,
            totalSolventadas: 0,
            importeTotalSolventadas: 0,
            importePendienteTotalSolventadas: 0,
            totalPorcentajeSolventadas: 0,
            totalPorSolventar: 0,
            importeTotalPorSolventar: 0,
            importePendienteTotalPorSolventar: 0,
            totalPorResponder: 0,
            importeTotalPorResponder: 0,
            importePendienteTotalPorResponder: 0,
            totalPendientesYPorResponder: 0,
            importeTotalPendientesYPorResponder: 0,
            importePendienteTotalPendientesYPorResponder: 0,
            totalRespuestaEnviadaParcial: 0,
            importeTotalRespuestaEnviadaParcial: 0,
            importePendienteTotalRespuestaEnviadaParcial: 0,
            totalRespuestaEnviadaCompleta: 0,
            importeTotalRespuestaEnviadaCompleta: 0,
            importePendienteTotalRespuestaEnviadaCompleta: 0,
            totalDesglose: 0,
            totalDesgloseSolventado: 0,
            totalDesglosePorSolventar: 0,
            totalDesgloseEnviadoEnte: 0,
            totalDesglosePorEnviar: 0,
            auditorias: [],
            observacionesPendientesyPorResponder: [],
            observacionesRespuestaEnviadaParcial: [],
            observacionesRespuestaEnviadaCompleta: [],
          };
        }

        // Agregar la auditoría al ente
        acc[descripcion].auditorias.push(auditoria);

        // Agregar detalles de observaciones de auditorias al por estatus
        acc[descripcion].observacionesPendientesyPorResponder.push(
          ...auditoria.pendientesyPorResponder,
        );
        acc[descripcion].observacionesRespuestaEnviadaParcial.push(
          ...auditoria.respuestaEnviadaParcial,
        );
        acc[descripcion].observacionesRespuestaEnviadaCompleta.push(
          ...auditoria.respuestaEnviadaCompleta,
        );

        // Agregar totales de datos observaciones de auditorias al ente
        acc[descripcion].totalObservaciones = this.$ObjSumar(
          acc[descripcion].auditorias,
          'cantidadObservaciones',
        );
        acc[descripcion].importeTotalObservaciones = this.$ObjSumar(
          acc[descripcion].auditorias,
          'totalObservacionesImporte',
        );
        acc[descripcion].importePendienteTotalObservaciones = this.$ObjSumar(
          acc[descripcion].auditorias,
          'totalObservacionesImportePendiente',
        );
        acc[descripcion].totalSolventadas = this.$ObjSumar(
          acc[descripcion].auditorias,
          'cantidadSolventadas',
        );
        acc[descripcion].importeTotalSolventadas = this.$ObjSumar(
          acc[descripcion].auditorias,
          'solventadasImporte',
        );
        acc[descripcion].importePendienteTotalSolventadas = this.$ObjSumar(
          acc[descripcion].auditorias,
          'solventadasImportePendiente',
        );
        acc[descripcion].totalPorcentajeSolventadas = this.$ObjSumar(
          acc[descripcion].auditorias,
          'porcentajeSolventadas',
        );
        acc[descripcion].totalPorSolventar = this.$ObjSumar(
          acc[descripcion].auditorias,
          'cantidadPorSolventar',
        );
        acc[descripcion].importeTotalPorSolventar = this.$ObjSumar(
          acc[descripcion].auditorias,
          'porSolventarImporte',
        );
        acc[descripcion].importePendienteTotalPorSolventar = this.$ObjSumar(
          acc[descripcion].auditorias,
          'porSolventarImportePendiente',
        );
        acc[descripcion].totalPorResponder = this.$ObjSumar(
          acc[descripcion].auditorias,
          'cantidadPorResponder',
        );
        acc[descripcion].importeTotalPorResponder = this.$ObjSumar(
          acc[descripcion].auditorias,
          'porResponderImporte',
        );
        acc[descripcion].importePendienteTotalPorResponder = this.$ObjSumar(
          acc[descripcion].auditorias,
          'porResponderImportePendiente',
        );
        acc[descripcion].totalPendientesYPorResponder = this.$ObjSumar(
          acc[descripcion].auditorias,
          'cantidadPendientesYPorResponder',
        );
        acc[descripcion].importeTotalPendientesYPorResponder = this.$ObjSumar(
          acc[descripcion].auditorias,
          'importePendientesYPorResponder',
        );
        acc[descripcion].importePendienteTotalPendientesYPorResponder = this.$ObjSumar(
          acc[descripcion].auditorias,
          'importePendientePendientesYPorResponder',
        );
        acc[descripcion].totalRespuestaEnviadaParcial = this.$ObjSumar(
          acc[descripcion].auditorias,
          'cantidadRespuestaEnviadaParcial',
        );
        acc[descripcion].importeTotalRespuestaEnviadaParcial = this.$ObjSumar(
          acc[descripcion].auditorias,
          'importeRespuestaEnviadaParcial',
        );
        acc[descripcion].importePendienteTotalRespuestaEnviadaParcial = this.$ObjSumar(
          acc[descripcion].auditorias,
          'importePendienteRespuestaEnviadaParcial',
        );
        acc[descripcion].totalRespuestaEnviadaCompleta = this.$ObjSumar(
          acc[descripcion].auditorias,
          'cantidadRespuestaEnviadaCompleta',
        );
        acc[descripcion].importeTotalRespuestaEnviadaCompleta = this.$ObjSumar(
          acc[descripcion].auditorias,
          'importeRespuestaEnviadaCompleta',
        );
        acc[descripcion].importePendienteTotalRespuestaEnviadaCompleta = this.$ObjSumar(
          acc[descripcion].auditorias,
          'importePendienteRespuestaEnviadaCompleta',
        );
        acc[descripcion].totalDesglose = this.$ObjSumar(acc[descripcion].auditorias, 'desglose');
        acc[descripcion].totalDesgloseSolventado = this.$ObjSumar(
          acc[descripcion].auditorias,
          'desgloseSolventado',
        );
        acc[descripcion].totalDesglosePorSolventar = this.$ObjSumar(
          acc[descripcion].auditorias,
          'desglosePorSolventar',
        );
        acc[descripcion].totalDesgloseEnviadoEnte = this.$ObjSumar(
          acc[descripcion].auditorias,
          'desgloseEnviadoEnte',
        );
        acc[descripcion].totalDesglosePorEnviar = this.$ObjSumar(
          acc[descripcion].auditorias,
          'desglosePorEnviar',
        );

        return acc;
      }, {});

      // Convertir el objeto agrupado en un array
      const auditoriasPorEnteFiscalizador = Object.values(agruparPorEnte);
      return auditoriasPorEnteFiscalizador;
    },
    mixGetTotalesObservaciones() {
      const { mixGetEntesFiscalizadores } = this;
      const observacionesPendientesyPorResponder = [];
      const observacionesRespuestaEnviadaParcial = [];
      const observacionesRespuestaEnviadaCompleta = [];
      if (mixGetEntesFiscalizadores.length < 1) {
        return {
          totalObservaciones: 0,
          importeTotalObservaciones: 0,
          importePendienteTotalObservaciones: 0,
          totalSolventadas: 0,
          importeTotalSolventadas: 0,
          importePendienteTotalSolventadas: 0,
          totalPorcentajeSolventado: 0,
          totalPorSolventar: 0,
          importeTotalPorSolventar: 0,
          importePendienteTotalPorSolventar: 0,
          totalPorResponder: 0,
          importeTotalPorResponder: 0,
          importePendienteTotalPorResponder: 0,
          totalPendientesYPorResponder: 0,
          importeTotalPendientesYPorResponder: 0,
          importePendienteTotalPendientesYPorResponder: 0,
          totalRespuestaEnviadaParcial: 0,
          importeTotalRespuestaEnviadaParcial: 0,
          importePendienteTotalRespuestaEnviadaParcial: 0,
          totalRespuestaEnviadaCompleta: 0,
          importeTotalRespuestaEnviadaCompleta: 0,
          importePendienteTotalRespuestaEnviadaCompleta: 0,
          totalDesglose: 0,
          totalDesgloseSolventado: 0,
          totalDesglosePorSolventar: 0,
          totalDesgloseEnviadoEnte: 0,
          totalDesglosePorEnviar: 0,
          observacionesPendientesyPorResponder: [],
          observacionesRespuestaEnviadaParcial: [],
          observacionesRespuestaEnviadaCompleta: [],
        };
      }
      this.mixGetEntesFiscalizadores.forEach((ente) => {
        observacionesPendientesyPorResponder.push(...ente.observacionesPendientesyPorResponder);
        observacionesRespuestaEnviadaParcial.push(...ente.observacionesRespuestaEnviadaParcial);
        observacionesRespuestaEnviadaCompleta.push(...ente.observacionesRespuestaEnviadaCompleta);
      });
      return {
        totalObservaciones: this.$ObjSumar(mixGetEntesFiscalizadores, 'totalObservaciones'),
        importeTotalObservaciones: this.$ObjSumar(
          mixGetEntesFiscalizadores,
          'importeTotalObservaciones',
        ),
        importePendienteTotalObservaciones: this.$ObjSumar(
          mixGetEntesFiscalizadores,
          'importePendienteTotalObservaciones',
        ),
        totalSolventadas: this.$ObjSumar(mixGetEntesFiscalizadores, 'totalSolventadas'),
        importeTotalSolventadas: this.$ObjSumar(
          mixGetEntesFiscalizadores,
          'importeTotalSolventadas',
        ),
        importePendienteTotalSolventadas: this.$ObjSumar(
          mixGetEntesFiscalizadores,
          'importePendienteTotalSolventadas',
        ),
        totalPorcentajeSolventado:
          this.$numberRound(this.$ObjSumar(mixGetEntesFiscalizadores, 'totalSolventadas') * 100)
            / this.$ObjSumar(mixGetEntesFiscalizadores, 'totalObservaciones') || 0,
        totalPorSolventar: this.$ObjSumar(mixGetEntesFiscalizadores, 'totalPorSolventar'),
        importeTotalPorSolventar: this.$ObjSumar(
          mixGetEntesFiscalizadores,
          'importeTotalPorSolventar',
        ),
        importePendienteTotalPorSolventar: this.$ObjSumar(
          mixGetEntesFiscalizadores,
          'importePendienteTotalPorSolventar',
        ),
        totalPorResponder: this.$ObjSumar(mixGetEntesFiscalizadores, 'totalPorResponder'),
        importeTotalPorResponder: this.$ObjSumar(
          mixGetEntesFiscalizadores,
          'importeTotalPorResponder',
        ),
        importePendienteTotalPorResponder: this.$ObjSumar(
          mixGetEntesFiscalizadores,
          'importePendienteTotalPorResponder',
        ),
        totalPendientesYPorResponder: this.$ObjSumar(
          mixGetEntesFiscalizadores,
          'totalPendientesYPorResponder',
        ),
        importeTotalPendientesYPorResponder: this.$ObjSumar(
          mixGetEntesFiscalizadores,
          'importeTotalPendientesYPorResponder',
        ),
        importePendienteTotalPendientesYPorResponder: this.$ObjSumar(
          mixGetEntesFiscalizadores,
          'importePendienteTotalPendientesYPorResponder',
        ),
        totalRespuestaEnviadaParcial: this.$ObjSumar(
          mixGetEntesFiscalizadores,
          'totalRespuestaEnviadaParcial',
        ),
        importeTotalRespuestaEnviadaParcial: this.$ObjSumar(
          mixGetEntesFiscalizadores,
          'importeTotalRespuestaEnviadaParcial',
        ),
        importePendienteTotalRespuestaEnviadaParcial: this.$ObjSumar(
          mixGetEntesFiscalizadores,
          'importePendienteTotalRespuestaEnviadaParcial',
        ),
        totalRespuestaEnviadaCompleta: this.$ObjSumar(
          mixGetEntesFiscalizadores,
          'totalRespuestaEnviadaCompleta',
        ),
        importeTotalRespuestaEnviadaCompleta: this.$ObjSumar(
          mixGetEntesFiscalizadores,
          'importeTotalRespuestaEnviadaCompleta',
        ),
        importePendienteTotalRespuestaEnviadaCompleta: this.$ObjSumar(
          mixGetEntesFiscalizadores,
          'importePendienteTotalRespuestaEnviadaCompleta',
        ),
        totalDesglose: this.$ObjSumar(mixGetEntesFiscalizadores, 'totalDesglose'),
        totalDesgloseSolventado: this.$ObjSumar(
          mixGetEntesFiscalizadores,
          'totalDesgloseSolventado',
        ),
        totalDesglosePorSolventar: this.$ObjSumar(
          mixGetEntesFiscalizadores,
          'totalDesglosePorSolventar',
        ),
        totalDesgloseEnviadoEnte: this.$ObjSumar(
          mixGetEntesFiscalizadores,
          'totalDesgloseEnviadoEnte',
        ),
        totalDesglosePorEnviar: this.$ObjSumar(mixGetEntesFiscalizadores, 'totalDesglosePorEnviar'),
        observacionesPendientesyPorResponder,
        observacionesRespuestaEnviadaParcial,
        observacionesRespuestaEnviadaCompleta,
      };
    },
    mixGetDetallesEtiquetas() {
      const observacionesDetalles = [];
      this.mixGetAuditorias.forEach((auditoria) => {
        auditoria.informes.forEach((informe) => {
          informe.observaciones.forEach((observacion) => {
            observacion.detalles.forEach((detalle) => {
              observacionesDetalles.push(detalle);
            });
          });
        });
      });
      return observacionesDetalles;
    },
    mixGetDetallesPorEtiqueta() {
      const etiquetas = [...this.mixGetCatalogoAuditoriaEtiquetas];
      const etiquetasConDetalles = etiquetas.map((etiqueta) => {
        const detalles = this.mixGetDetallesEtiquetas.filter((detalle) => detalle.etiquetas.find(
          (etiquetaDetalle) => etiquetaDetalle.idAuditoriaEtiqueta === etiqueta.id,
        ));
        return {
          ...etiqueta,
          detalles,
        };
      })
        .filter((etiqueta) => etiqueta.detalles.length > 0);
      return etiquetasConDetalles;
    },
  },
  watch: {
    mixGetAuditorias: {
      handler() {
        this.setAuditoriasFiltro();
      },
    },
  },
};
